import React, { useCallback, useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Button,
  Input,
} from "reactstrap";
import ReactTable from "react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

function WorkflowsMenuSectionDashboard(props) {

  return (
    <Col md={12}>
      {/* Status Summary */}
      {!props.isMyworksScreen && (
        <Card className="main-card card-of-problemarea mb-1 mt-2">
          <CardBody>
            <Row>
              <Col md="12">
                <CardTitle
                  className="mt-2 border mb-0 p-2 text-center"
                  style={{
                    fontSize: "17px",
                    color: "#243837",
                    backgroundColor: "#B1FA63",
                  }}
                >
                  OverAll Workflow Task Status
                </CardTitle>

                <div className="d-flex border p-1 justify-content-around">
                  {props.statusCounts ? (
                    props.statusCounts.map((item, index) => (
                      <div key={index} className="border pt-2 pb-2 pl-2 pr-2 m-1">
                        <h5 className="text-center" style={{ fontSize: '18px' }}>
                          <b>{item.status}</b>
                        </h5>
                        <h6 className="text-center">
                          <b>{item.count}</b>
                        </h6>
                      </div>
                    ))
                  ) : (
                    <p>Loading Statistics...</p>
                  )}
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      )}

      {/* Task Grid */}
      <Card className="p-4 mt-2 card-of-problemarea">
        <Row>
          <Col md={12}>
            {props.isMyworksScreen &&
              props.notificationsDetails && props.notificationsDetails.action && (
                <Card className="notification-card p-3 mb-2 card-of-problemarea">
                  <Row>
                    <Col md={10}>
                      <strong>
                        {props.notificationsDetails.details}
                      </strong>
                    </Col>

                    <Col md={2} className="text-end">
                      <Button
                        close
                        className="close-button"
                        onClick={() =>
                          props.setNotificationsDetails({
                            tabs: 1,
                            details: "",
                            action: false,
                            searchparams: "",
                          })
                        }
                      />
                    </Col>
                  </Row>
                </Card>
              )}

            <div className="d-flex align-items-center mb-3 justify-content-end">
              
              <button
                title="Download Workflows Tasks"
                className="info-button-background-none"
                onClick={() =>
                  props.ExportCSV(
                    props.exlDownloadFilter,
                    "SW_Workflows_Tasks_Status_" +
                      props.formattedDateTime
                  )
                }
              >
                <FontAwesomeIcon
                  icon={faDownload}
                  style={{ fontSize: "27px" }}
                />
              </button>

              {!props.isMyworksScreen && (
                <select
                  className="form-control w-25 ml-3"
                  value={props.executorId || ""}
                  onChange={props.handleChangeAssignedTo}
                >
                  <option value="">-- All --</option>
                  {props.teamMemberList &&
                    props.teamMemberList.map((member) => (
                      <option
                        key={member.employeeId}
                        value={member.employeeId}
                      >
                        {member.employeeName}
                      </option>
                    ))}
                </select>
              )}

              <Input
                type="text"
                className={`w-25 ml-3 ${
                  props.isMyworksScreen ? "mb-3" : ""
                }`}
                placeholder="Search Text"
                value={props.searchText}
                onChange={props.handaleSearchStoreHealth}
              />
            </div>

            {!props.isMyworksScreen && (
              <div>
                <label className="mr-3">
                  <input
                    type="radio"
                    checked={props.statusFilter === "All"}
                    onChange={() =>
                      props.setStatusFilter("All")
                    }
                  />
                  &nbsp;
                  <b>All</b>
                </label>
                
                {props.statusCounts && props.statusCounts.map((item, index) => (
                  <label
                    key={index}
                    className="mr-3"
                  >
                    <input
                      type="radio"
                      checked={
                        props.statusFilter === item.status
                      }
                      onChange={() =>
                        props.setStatusFilter(item.status)
                      }
                    />
                    &nbsp;
                    <b>{item.status}</b>
                  </label>  
                ))}
              </div>
            )}
          </Col>
        </Row>

        <ReactTable
          data={props.filterStorehealthAllTasks}
          columns={props.allTasksColumns}
          className="-fixed -highlight -striped"
          defaultPageSize={5}
          noDataText="No Data Found."
          getTheadProps={() => ({
            style: {
              overflowY: "hidden",
              background: "#B1FA63",
              color: "#243837",
            },
          })}
        />
      </Card>
    </Col>
  );
}

export default WorkflowsMenuSectionDashboard;